import { dismissFolderSelectorButton } from 'owa-locstrings/lib/strings/dismissfolderselectorbutton.locstring.json';
import loc from 'owa-localize';
import * as React from 'react';
import { DefaultButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';

import {
    isCreatingNewFolder,
    isUserEnteringNewFolderName,
} from '../selectors/createNewFolderSelectors';
import { isLoading } from '../selectors/loadingSelectors';
import { observer } from 'mobx-react-lite';

const styles = require('./FolderSelectorBottomPart.scss');

export interface FolderSelectorBottomPartProps {
    onPrimaryButtonClicked: () => void;
    onCancelButtonClicked: () => void;
    primaryButtonString: () => string;
}

export const FolderSelectorBottomPart = observer(function FolderSelectorBottomPart(
    props: FolderSelectorBottomPartProps
) {
    const { primaryButtonString } = props;
    const disablePrimaryButton =
        isLoading() || isUserEnteringNewFolderName() || isCreatingNewFolder();

    return (
        <div className={styles.container}>
            <div className={styles.buttonsContainer}>
                <PrimaryButton
                    disabled={disablePrimaryButton}
                    className={styles.primaryButton}
                    text={primaryButtonString()}
                    onClick={props.onPrimaryButtonClicked}
                />

                <DefaultButton
                    text={loc(dismissFolderSelectorButton)}
                    onClick={props.onCancelButtonClicked}
                />
            </div>
        </div>
    );
});
